module.exports = __webpack_public_path__ + "media/assets/faria_products/SSO office 365-e95e5402ec311af6bf48e0cda1a61740e97317110c107885466d98e15bec1633.png";